import React, { Component } from 'react';
import './Inseriscicard.css';
//import intc from '../../images/public/registeration/intc.png';
import clos from '../../images/public/registeration/clos.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserView, MobileView, isFirefox, isMobileOnly, isAndroid } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { luhncalc } from '../../libs/fetch';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import Cleave from 'cleave.js/react';
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
import { getCardOptions } from '../../libs/fetch'

const cookies = new Cookies();

class Inseriscicard extends Component {
    constructor(props) {
        super(props);

        let params = null;
        this.enableLogs = true;
        if (this.enableLogs) console.log('[Inseriscicard]', params);
        this.cardType = -1;
        this.state = {
            userInfo: props.userInfo ? props.userInfo : null,
            code: '',
            maxLength: 23,
            cardSerialNumber: null,
            cardIsvalid: false,
            isLoading: false,
            errmsg: null,
            errorFlg: false,
            limitedPurchase: null,
        };

    }

    componentDidMount() {
        let limitedPurchase = localStorage.getItem('limitedPurchase');
        if (limitedPurchase == 'null') {
            this.setState({ limitedPurchase: null });
        } else {
            this.setState({ limitedPurchase: limitedPurchase });
        }

    }

    gotoConfigminore = (e) => {
        e.preventDefault();
        return this.props.history.push('/Configminore');
    }

    validateCard = () => {
        this.forceUpdate(async () => {
            let strCard = this.state.code;
            let card_code = (this.cardType == 0) ? strCard.substr(0, 2) + "-" + strCard.substr(2, 20) + "-" + strCard.substr(22, 1) :
                strCard.substr(0, 8) + "-" + strCard.substr(8, 3) + "-" + strCard.substr(11, 3)
            if (this.enableLogs) console.log("[Inseriscicard] getCardOptions @card_code: ", card_code);
            this.setState({ isLoading: true });
            try {
                const response = await getCardOptions(null, card_code);
                this.setState({ isLoading: false });
                console.log("[Inseriscicard] getCardOptions @response: ", response);
                if (response && response.status === "success") {
                    //Card can be assigned to the user.
                    this.setState({ cardIsvalid: true });
                    let cart = {
                        cardNumber: card_code,
                    }
                    localStorage.setItem("cart", JSON.stringify(cart));
                    return;
                } else {
                    this.setState({
                        cardIsvalid: false,
                        errorFlg: true,
                        errmsg: (response && response.message) || 'Validation failed'
                    });
                    //Card cannot be assigned to the user.
                }
            } catch (error) {
                this.setState({ isLoading: false, cardIsvalid: false });
            }
        })
    }

    handleChangeCode = (e) => {
        e.preventDefault();
        let cardStr = e.target.value

        cardStr = cardStr.replace(/[^0-9a-zA-Z]/, '')
        if (cardStr.length > 1) {
            if (cardStr.slice(0, 2) == "01" || cardStr.slice(0, 2) == "28" || cardStr.slice(0, 2) == "29" || cardStr.slice(0, 2) == "30") {
                // if(this.enableLogs)  console.log("[Inseriscicard] Skidata Card! ", cardStr.slice(0, 2));
                this.cardType = 0;
                this.setState({ maxLength: 23 });
            } else {
                // if(this.enableLogs)  console.log("[Inseriscicard] Axess Card! ", cardStr.slice(0, 2));
                this.cardType = 1;
                this.setState({ maxLength: 14 });
            }
        } else {
            this.cardType = -1;
            this.setState({ maxLength: 23 });
        }
        this.setState({ code: cardStr.toUpperCase() });
        if (this.enableLogs) console.log("[Inseriscicard] handleChangeCode: ", "cardType: ", this.cardType, "Card Number: ", this.state.code);
        if (cardStr.length == this.state.maxLength) this.validateCard();
        else this.setState({
            cardIsvalid: false,
            errorFlg: false
        });
        return
    }

    alertResponse(info) {
        switch (info.type) {
            case "closeButton":
                this.setState({ errorFlg: false })
                break;
            case "actionButton":
                if (info.option1 == "attention") {
                    this.setState({ errorFlg: false })
                    break;
                }
        }
    }

    canPurchase() {
        var canBuy = true;
        if (this.state.limitedPurchase && this.state.limitedPurchase == 'axess' && !this.state.errorFlg && this.cardType == 0) canBuy = false;
        if (this.state.limitedPurchase && this.state.limitedPurchase == 'skidata' && !this.state.errorFlg && this.cardType == 1) canBuy = false;
        return canBuy
    }

    render() {
        if (this.enableLogs) console.log("[Inseriscicard] states: ", ": ", this.state);
        return (
            <Router>
                <div>
                    <div>
                        <BrowserView>
                            <div className="containermbcgicb">
                                {tr.userlng() == 'IT' && <div className="navici"></div>}
                                {tr.userlng() != 'IT' && <div className="navice"></div>}
                                <div className="containermicb">
                                    <div className="closic">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="intc">
                                        {tr.t("Insertcardcode")}
                                    </div>
                                    <div className={isFirefox ? "containernicb1f" : "containernicb1"}>
                                        {tr.t("Insertback")}
                                    </div>
                                    <div className="containeriicb">
                                        <label>
                                            <input type="text" name="name" placeholder={tr.t("Codenum")} spellCheck="false" className={this.cardType == -1 ? (isFirefox ? "txlsic21f" : "txlsic21") : this.state.cardIsvalid ? (isFirefox ? "txlsic22f-ticked" : "txlsic22-ticked") : (isFirefox ? "txlsic22f" : "txlsic22")} maxLength={this.state.maxLength} value={this.state.code} onChange={this.handleChangeCode} />
                                        </label>
                                    </div>
                                    <div className="containeriicbCleave"> 
                                        <label>
                                            {this.cardType == 0 && <Cleave
                                                className={isFirefox ? "txlsic3f" : "txlsic3"}
                                                options={{
                                                    delimiters: ['-', ' ', ' ', ' ', ' ', '-'],
                                                    blocks: [2, 4, 4, 4, 4, 4, 1],
                                                    uppercase: true
                                                }}
                                                value={this.state.code}
                                                disabled={true}
                                            />}
                                            {this.cardType == 1 && <Cleave
                                                className={isFirefox ? "txlsic3f" : "txlsic3"}
                                                options={{
                                                    delimiters: ['-', '-'],
                                                    blocks: [8, 3, 3],
                                                    uppercase: true
                                                }}
                                                value={this.state.code}
                                                disabled={true}
                                            />}
                                        </label>
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnic">{this.state.errmsg}</div>} */}
                                    <div className={isFirefox ? "containernicb2f" : "containernicb2"}>
                                        {!this.state.limitedPurchase && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("Informskidata")}</div>}
                                        {!this.state.limitedPurchase && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("Informaxess")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'skidata' && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("Informskidata")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'axess' && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("Informaxess")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'axess' && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("YouCannotBuyThisCard")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'skidata' && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("YouCannotBuyThisCard")}</div>}
                                    </div>
                                    <div className="containerbicb">
                                        <form>
                                            <button className="icbtn" disabled={!this.state.cardIsvalid || !this.canPurchase()} onClick={this.gotoConfigminore}>{tr.t("Next")}</button>
                                        </form>
                                    </div>
                                    <div className="marginBottomic"></div>
                                </div>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="containermbcgicm">
                                <div className="navicm"></div>
                                <div className={(isMobileOnly || isAndroid) ? "containermicm" : "containermict"}>
                                    <div className="closicm">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="intcm">
                                        {tr.t("Insertcardcode")}
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containernicm1" : "containernict1"}>
                                        {tr.t("Insertback")}
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containeriicm" : "containeriict"}>
                                        <label>
                                            <input type="text" name="name" placeholder={tr.t("Codenum")} spellcheck="false" className={this.cardType == -1 ? "txlsic21m" : this.state.cardIsvalid ? "txlsic22m-ticked" : "txlsic22m"} maxLength={this.state.maxLength} value={this.state.code} onChange={this.handleChangeCode} />
                                        </label>
                                    </div>
                                    <div className="containeriicmCleave">
                                        <label>
                                            {this.cardType == 0 && <Cleave
                                                className="txlsic3m"
                                                options={{
                                                    delimiters: ['-', ' ', ' ', ' ', ' ', '-'],
                                                    blocks: [2, 4, 4, 4, 4, 4, 1],
                                                    uppercase: true
                                                }}
                                                value={this.state.code}
                                                disabled={true}
                                            />}
                                            {this.cardType == 1 && <Cleave
                                                className="txlsic3m"
                                                options={{
                                                    delimiters: ['-', '-'],
                                                    blocks: [8, 3, 3],
                                                    uppercase: true
                                                }}
                                                value={this.state.code}
                                                disabled={true}
                                            />}
                                        </label>
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnicm">{this.state.errmsg}</div>} */}
                                    <div className={(isMobileOnly || isAndroid) ? "containernicm2" : "containernict2"}>
                                        {!this.state.limitedPurchase && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("Informskidata")}</div>}
                                        {!this.state.limitedPurchase && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("Informaxess")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'skidata' && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("Informskidata")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'axess' && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("Informaxess")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'axess' && !this.state.errorFlg && this.cardType == 0 && <div>{tr.t("YouCannotBuyThisCard")}</div>}
                                        {this.state.limitedPurchase && this.state.limitedPurchase == 'skidata' && !this.state.errorFlg && this.cardType == 1 && <div>{tr.t("YouCannotBuyThisCard")}</div>}
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containerbicm" : "containerbict"}>
                                        <form>
                                            <button className="icbtnm" disabled={!this.state.cardIsvalid} onClick={this.gotoConfigminore}>{tr.t("Next")}</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </MobileView>
                        {this.state.errorFlg ?
                            <div className="containerModal">
                                {this.state.errorFlg ?
                                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                                }
                            </div> : null
                        }
                    </div>
                    <WaitLoad enable={this.state.isLoading} />
                </div>
            </Router>
        );
    }
}

export default Inseriscicard;


// WEBPACK FOOTER //
// ./src/screens/Inseriscicard/Inseriscicard.js